import { render, staticRenderFns } from "./TrackingRegister.vue?vue&type=template&id=ccec9a58"
import script from "./TrackingRegister.vue?vue&type=script&lang=js"
export * from "./TrackingRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports